import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { fmtDate } from "@/lib/format";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export function EventPicker({ value, onChange, allowAll, testid = "event-picker" }) {
  const [events, setEvents] = useState([]);
  useEffect(() => {
    api.get("/admin/events").then((r) => {
      setEvents(r.data.items);
      if (!allowAll && !value && r.data.items[0]) onChange(r.data.items[0].id);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <Select value={value || "all"} onValueChange={(v) => onChange(v === "all" ? null : v)}>
      <SelectTrigger className="w-72 bg-white" data-testid={testid}><SelectValue placeholder="Pilih event" /></SelectTrigger>
      <SelectContent>
        {allowAll && <SelectItem value="all">Semua event</SelectItem>}
        {events.map((e) => <SelectItem key={e.id} value={e.id}>{e.name} · {fmtDate(e.date)}</SelectItem>)}
      </SelectContent>
    </Select>
  );
}
